(ns iris.worker-pool
  (:require
   [cljs.core.async :refer [go <!]]
   [cljs-workers.core :as worker-main]))


(defonce ncores (or (.-hardwareConcurrency js/navigator) 4))

(defonce nworkers (cond (>= ncores 8) 4
                        (>= ncores 4) 2
                        :else 1))

;; (defonce nworkers 1)

(println "ncores:" ncores)
(println "nworkers:" nworkers)

(defonce worker-pool (atom nil))

(defn init! []
  (println "worker-pool init!")
  (reset! worker-pool (worker-main/create-pool nworkers js/webWorkerFile)))


(defonce print-result (fn [result-chan]
                                    (go
                                      (let [result (<! result-chan)]
                                        (.debug js/console (str "MAIN>WORK::" result))
                                        result))))


(defn do! [arguments]
  (worker-main/do-with-pool! @worker-pool arguments))

(defn do-print-result! [arguments]
  (print-result (worker-main/do-with-pool! @worker-pool arguments)))

(defn do-all! [arguments]
  (worker-main/do-for-pool! @worker-pool arguments))